var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.nav
    ? _c("div", { staticClass: "z-page-nav" }, [
        _c("div", { staticClass: "z-page-nav__inner" }, [
          _vm.nav.prev && _vm.nav.prev.text
            ? _c(
                "a",
                {
                  staticClass: "z-page-nav__btn z-page-nav__btn--prev",
                  class: !_vm.nav.prev && "z-page-nav__btn--disabled",
                  attrs: {
                    href: _vm.nav.prev
                      ? _vm.nav.prev.link
                      : "javascript:void(0)",
                    title: _vm.nav.prev.text,
                  },
                },
                [
                  _c("z-icon", {
                    attrs: {
                      name: "arrow",
                      dir: "left",
                      width: "20",
                      height: "34",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "z-page-nav__divider" },
            [
              _c("z-icon", {
                attrs: { name: "sg-element", width: "22", height: "22" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.nav.next && _vm.nav.next.text
            ? _c(
                "a",
                {
                  staticClass: "z-page-nav__btn z-page-nav__btn--next",
                  class: !_vm.nav.next && "z-page-nav__btn--disabled",
                  attrs: {
                    href: _vm.nav.next
                      ? _vm.nav.next.link
                      : "javascript:void(0)",
                    title: _vm.nav.next.text,
                  },
                },
                [
                  _c("z-icon", {
                    attrs: {
                      name: "arrow",
                      dir: "right",
                      width: "20",
                      height: "34",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }